import { generateAuthorsPageProps } from 'utils/next'
import { setPageCacheControlHeaders } from 'utils/cache'
import FEATURE_TOGGLES from 'constants/featureToggles'
import { AuthorRender } from 'components/AuthorRender'

export async function getServerSideProps(context) {
  setPageCacheControlHeaders(context.res)
  const serverSideProps = await generateAuthorsPageProps(context)

  const authorsEnabled =
    serverSideProps?.props?.featureToggleObject?.[
      FEATURE_TOGGLES[process.env.NEXT_PUBLIC_SITE_ENVIRONMENT].ACX_WEB_ENABLE_AUTHORS
    ]
  if (!authorsEnabled) {
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    }
  }

  // Check if notFound was passed in from generateAuthorsPageProps after LD check above
  // If so, return the notFound object to the page to return a 404 page not found
  if (serverSideProps?.props?.content?.notFound) {
    return serverSideProps.props.content
  }

  return { ...serverSideProps }
}

export default function AuthorsPage({
  content,
  isMobile,
  completePageUrl,
  articlesAuthor,
  pageHost,
}) {
  return (
    <AuthorRender
      pageContent={content}
      isMobileUA={isMobile}
      completePageUrl={completePageUrl}
      articlesAuthor={articlesAuthor}
      pageHost={pageHost}
    />
  )
}
